import React, { createContext, useContext } from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../../Context/ZooPassAnswersContext";
import {StepTitleContent} from "../PanelContents/StepTitleContent";
import {ImageAnswerComponent} from "../PanelContents/ImageAnswer";
import ZooPassLocalStateUtility from "../../Utilities/ZooPassLocalStateUtility";

export const Step1Panel : React.FC = () => {

    let {
        imageAnswers,
        textTitles,
        loading
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading,
        updateContext
    } = useZooPassAppAnswersContext();
    
    const handleValueClick = (value : null | 0 | 1) => {
        if(answersData != null && (value === 0 || value === 1)){
            answersData.step1Value = value;
            answersData.previousStep = 1;
            answersData.step = 2;
            ZooPassLocalStateUtility.SetLocalState(answersData);
            updateContext({type: "setAnswers", value: answersData});
        }
    };

    const handleRadioKeyPress = (event : any, value : null | 0 | 1) => {
        if(!event.altKey && !event.metaKey && !event.shiftKey && event.key === 'Enter') {
            handleValueClick(value);
        }
    };
    
    return !answersLoading && !loading && 
        textTitles !== null &&
        answersData !== null && (answersData.step == 1 || answersData.step == 0) && (
        <div className="container d-block">
            <StepTitleContent textTitle={textTitles.get("ZooPass:PageContent:01")}/>
            <div className="row g-4 mx-auto row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 justify-content-center w-auto">
                <ImageAnswerComponent imageAnswerData={imageAnswers.get("ZooPass:PageAnswer:01:Me")} nameValue="step1"
                                      onKeyboardPress={(event) => handleRadioKeyPress(event, 0)}
                                      onClick={() => handleValueClick(0)} key="forMe" imageAltValue={null}/>
                <ImageAnswerComponent imageAnswerData={imageAnswers.get("ZooPass:PageAnswer:01:Gift")} nameValue="step1"
                                      onKeyboardPress={(event) => handleRadioKeyPress(event, 1)}                      
                                      onClick={() => handleValueClick(1)} key="forSomeoneElse" imageAltValue={null}/>
            </div>
        </div>
    );
};

